import { trans } from "@mongez/localization";
import { Form } from "@mongez/react-form";
import { useSendMessage } from "core/contact-us";
import {
  EmailInput,
  errorToast,
  FileInput,
  PhoneNumberInput,
  SubmitButton,
  successToast,
  TextareaInput,
  TextInput,
} from "~/design-system/components";

export function ContactForm() {
  const { sendMessage } = useSendMessage({
    onSuccess: () => {
      successToast(trans("contactUsPage.sendSuccessfully"));
    },
    onError: (error: any) => {
      errorToast(error);
    },
  });

  return (
    <div className="flex flex-col gap-8 sm:gap-12 lg:gap-16">
      <div className="flex flex-col items-center justify-center gap-4 sm:gap-6 lg:gap-7">
        <h3 className="text-night text-center text-3xl font-bold sm:text-4xl lg:text-5xl">
          {trans("contactUsPage.contactTitle")}
        </h3>
        <p className="font-avenir text-night/60 text-center text-lg font-medium sm:text-xl lg:text-2xl">
          {trans("contactUsPage.contactDescription")}
        </p>
      </div>
      <Form onSubmit={sendMessage}>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3 lg:gap-8">
          <TextInput
            name="name"
            placeholder={trans("name")}
            required
            classes={{
              input: "bg-white",
              wrapper: "sm:col-span-2 lg:col-span-1",
            }}
          />
          <EmailInput
            name="email"
            placeholder={trans("emailAddress")}
            required
            classes={{
              input: "bg-white",
              wrapper: "sm:col-span-2 lg:col-span-1",
            }}
          />
          <PhoneNumberInput
            id="phoneNumber"
            name="phoneNumber"
            placeholder={trans("phoneNumber")}
            required
            classes={{
              input: "bg-white",
              wrapperClassName: "col-span-1 sm:col-span-2 lg:col-span-1",
            }}
          />
          <FileInput
            name="file"
            placeholder={trans("inspirationPicture")}
            classes={{
              wrapper: "col-span-1 sm:col-span-2 lg:col-span-3",
              label: "w-fit",
            }}
            maxFiles={1}
            accept="image/*"
          />
          <TextInput
            name="subject"
            placeholder={trans("subject")}
            required
            classes={{
              input: "bg-white",
              wrapper: "col-span-1 sm:col-span-2 lg:col-span-3",
            }}
          />
          <TextareaInput
            name="message"
            placeholder={trans("contactUsPage.yourMessage")}
            required
            rows={4}
            classes={{
              input: "bg-white",
              wrapper: "col-span-1 sm:col-span-2 lg:col-span-3",
            }}
          />
        </div>
        <SubmitButton className="bg-primary-200 hover:bg-primary-300 border-night col-span-3 mt-8 w-full items-center justify-center border px-8 py-3 text-center text-base transition-colors duration-200 sm:mt-12 sm:text-lg lg:mt-16">
          {trans("submit")}
        </SubmitButton>
      </Form>
    </div>
  );
}
